module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-music.svg?72d1bcee410603d180c976b7eddc2899";